export const StarIcon = ({ filled }: { filled: boolean }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill={filled ? "#1D1C1C" : "none"}
    stroke={filled ? "#1D1C1C" : "#948D8D"}
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3l2.7 5.8 6.3.8-4.6 4.3 1.2 6.2L12 17.9 6.4 20.9l1.2-6.2L3 9.6l6.3-.8z" />
  </svg>
);
